import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.jpeg';
import { useAuth } from '../services/authContext';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [formError, setFormError] = useState('');
  const { login, error, loading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/dashboard');
  }, [user, navigate]);

  const handleChange = event =>
    setFormData(previous => ({ ...previous, [event.target.name]: event.target.value }));

  const handleSubmit = async event => {
    event.preventDefault();
    setFormError('');

    if (!formData.email || !formData.password) {
      setFormError('Please enter both email and password.');
      return;
    }

    const success = await login(formData.email, formData.password);
    if (success) navigate('/dashboard');
  };

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: 460 }}>
        <div className="auth-header">
          <img src={logo} alt="MCCT Logo" style={{ height: 72, marginBottom: '1rem', borderRadius: 8 }} />
          <h2>Mokorotlo College of Creative Technology</h2>
          <p style={{ color: 'var(--text-light)', marginTop: '0.25rem' }}>Sign in with your real system account</p>
        </div>

        {(formError || error) && <div className="error-message">{formError || error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@example.com"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
          <p style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.9rem' }}>
            <Link to="/forgot-password" style={{ color: 'var(--primary-color)' }}>Forgot your password?</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
